import vPlaceholder from "./v-placeholder.vue";

export default Vue => {
  Vue.component("v-placeholder", vPlaceholder);
};
